import { render, staticRenderFns } from "./ConfigurePointSuccess.vue?vue&type=template&id=09745e33&scoped=true&"
import script from "./ConfigurePointSuccess.vue?vue&type=script&lang=js&"
export * from "./ConfigurePointSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurePointSuccess.vue?vue&type=style&index=0&id=09745e33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09745e33",
  null
  
)

export default component.exports